import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="guardia"
export default class extends Controller {
  static targets = ["section", "sectionEcografia", "sectionRadiografia", "sectionMedication", "sectionDestination"]


  connect() {
    this.updateSection()
  }

  toggleSection() {
    this.updateSection()
  }

  updateSection() {
    const ecografiaYes = this.element.querySelector('input[name*="solicitud_ecografia"][value="true"]')
    const tomografiaYes = this.element.querySelector('input[name*="solicitud_tomografia"][value="true"]')
    const radiografiaYes = this.element.querySelector('input[name*="solicitud_radiografia"][value="true"]')

    const ecografiaChecked = ecografiaYes?.checked
    const tomografiaChecked = tomografiaYes?.checked
    const radiografiaChecked = radiografiaYes?.checked

    if (tomografiaChecked) {
      this.sectionTarget.classList.remove("d-none")
    } else {
      this.sectionTarget.classList.add("d-none")
    }

    if (ecografiaChecked) {
      this.sectionEcografiaTarget.classList.remove("d-none")
    } else {
      this.sectionEcografiaTarget.classList.add("d-none")
    }

    if (radiografiaChecked) {
      this.sectionRadiografiaTarget.classList.remove("d-none")
    } else {
      this.sectionRadiografiaTarget.classList.add("d-none")
    }

    const medicacionParenteral = this.element.querySelector('input[name*="medicacion"][value="via_parenteral"]')
    const medicacionOral = this.element.querySelector('input[name*="medicacion"][value="via_oral"]')

    const parenteralChecked = medicacionParenteral?.checked
    const oralChecked = medicacionOral?.checked

    if (parenteralChecked) {
      this.sectionMedicationTarget.classList.remove("d-none")
    } else if (oralChecked) {
      this.sectionMedicationTarget.classList.add("d-none")
    }

    const destinoInternacion = this.element.querySelector('input[name*="destino"][value="internacion"]')
    const destinoAlta = this.element.querySelector('input[name*="destino"][value="alta"]')

    const internacionChecked = destinoInternacion?.checked
    const altaChecked = destinoAlta?.checked

    if (internacionChecked) {
      this.sectionDestinationTarget.classList.remove("d-none")
    } else if (altaChecked) {
      this.sectionDestinationTarget.classList.add("d-none")
    }
  }
}
